import {
  axiosInstance as axios,
} from "../../redux/constants/axiosInstance";

import { API_URL, WORKFLOW_LIST_BY_COMPANY, WORKFLOW_CONDITION_TRIGGER, WORKFLOW_CONDITION_RULES, WORKFLOW_CONDITION_TASK_STATUS, WORKFLOW_CONDITION_TASK_LIST, WORKFLOW_ACTIONS, WORKFLOW_INFO, WORKFLOW_QUESTIONS, WORKFLOW_TASK_TYPE } from "../constants/type"

export const GetSubmodulesByModuleId = (moduleId) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/WorkFlow/FetchSubModule`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      moduleId
    }
  });
};

export const AddNewWorkflow = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/WorkFlow/AddWorkFlow`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
}

export const FetchWorkflowByCompany = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/WorkFlow/FetchWorkFlowByCompany`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });

    dispatch({
      type: WORKFLOW_LIST_BY_COMPANY,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}

export const FetchTriggers = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/WorkFlow/FetchTrigger`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });

    dispatch({
      type: WORKFLOW_CONDITION_TRIGGER,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}

export const FetchRules = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/WorkFlow/FetchRules`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });

    dispatch({
      type: WORKFLOW_CONDITION_RULES,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}

export const FetchTaskStatus = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/WorkFlow/TaskStatusDropdown`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });

    dispatch({
      type: WORKFLOW_CONDITION_TASK_STATUS,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}


export const FetchTaskList = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/WorkFlow/GetTaskList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });

    dispatch({
      type: WORKFLOW_CONDITION_TASK_LIST,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}

export const AddNewCondition = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/WorkFlow/AddWorkFlowCondition`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
}

export const AddNewAction = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/WorkFlow/AddWorkFlowAction`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
}

export const FetchActions = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/WorkFlow/FetchAction`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });

    dispatch({
      type: WORKFLOW_ACTIONS,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}

export const FetchTaskTypes = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/WorkFlow/WorkflowTaskType`,
      headers: {
        "Content-Type": "application/json",
      },
    });

    dispatch({
      type: WORKFLOW_TASK_TYPE,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}

export const FetchQuestions = (formId) => async (dispatch) => {

  console.log('Form Id', formId)
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/WorkFlow/FetchFormQuestion`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        formId: formId,
      },
    });

    dispatch({
      type: WORKFLOW_QUESTIONS,
      data: response.data
    })


  } catch (error) {
    console.error(error);
  }
}

export const FetchWorkflowById = (workFlowId) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/WorkFlow/FetchWorkFlowById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      workFlowId: workFlowId
    }
  });
}

export const TriggerWorkflowById = (workFlowId) => {
  return axios({
    method: "get",
    url: `${API_URL}/api/WorkFlow/TriggerWorkflow/${workFlowId}`,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export const DeleteWorkflowById = (workFlowId) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/WorkFlow/DeleteWorkFlow`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      workFlowId: workFlowId
    }
  });
}



//Done
// /api/WorkFlow/AddWorkFlow
// /api/WorkFlow/FetchSubModule
// /api/WorkFlow/AddWorkFlowCondition
// /api/WorkFlow/FetchRules
// /api/WorkFlow/FetchTrigger
// /api/WorkFlow/FetchAction
// /api/WorkFlow/FetchWorkFlowByCompany
// /api/WorkFlow/AddWorkFlowAction



//Pending
// /api/WorkFlow/UpdateWorkFlow
// /api/WorkFlow/FetchWorkFlowById
// /api/WorkFlow/FetchWorkFlowCondition
// /api/WorkFlow/FetchWorkFlowAction